export const getClipboardFiles = (clipboardData) => {
  const itemFiles = Array.from(clipboardData?.items || [])
    .filter((item) => item.kind === "file")
    .map((item) => item.getAsFile?.())
    .filter(Boolean);

  if (itemFiles.length) return itemFiles;
  return Array.from(clipboardData?.files || []).filter(Boolean);
};

export const isVisiblePasteRoot = (element) =>
  Boolean(
    element &&
      element.ownerDocument?.body?.contains(element) &&
      !element.closest?.("[hidden]"),
  );
